import { render, staticRenderFns } from "./BoardLayoutPage.vue?vue&type=template&id=485533f0&scoped=true&"
import script from "./BoardLayoutPage.vue?vue&type=script&lang=js&"
export * from "./BoardLayoutPage.vue?vue&type=script&lang=js&"
import style0 from "./BoardLayoutPage.vue?vue&type=style&index=0&id=485533f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485533f0",
  null
  
)

export default component.exports